import request from '@/untils/request'
import QS from 'qs'
import base_ from '@/untils/base';
/**
 * post方法，对应post请求
 * @desc注册请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const Wiki = {

    search: function(data) {
        return request({
            url: `${base_.url}/api.wiki/search`,
            method: 'post',
            data: QS.stringify(data),
        })
    },

    detail: function(data) {
        return request({
            url: `${base_.url}/api.wiki/detail`,
            method: 'post',
            data: QS.stringify(data),
            showloading: data.showloading,
        })
    },
    edit: function(data) {
        return request({
            url: `${base_.url}/api.wiki/editsave`,
            method: 'post',
            data: QS.stringify(data),
            showloading: true,
        })
    },
    addsave: function(data) {
        return request({
            url: `${base_.url}/api.wiki/addsave`,
            method: 'post',
            data: QS.stringify(data),
            showloading: true,
        })
    },
    price_edit: function(data) {
        return request({
            url: `${base_.url}/api.wiki/price_edit`,
            method: 'post',
            data: QS.stringify(data),
            showloading: true,
        })
    },
    price_add: function(data) {
        return request({
            url: `${base_.url}/api.wiki/price_add`,
            method: 'post',
            data: QS.stringify(data),
            showloading: true,
        })
    },
    price_del: function(data) {
        return request({
            url: `${base_.url}/api.wiki/price_del`,
            method: 'post',
            data: QS.stringify(data),
            showloading: true,
        })
    },
    del: function(data) {
        return request({
            url: `${base_.url}/api.wiki/del`,
            method: 'post',
            data: QS.stringify(data),
            showloading: true,
        })
    },
    recycle: function(data) {
        return request({
            url: `${base_.url}/api.wiki/recycle`,
            method: 'post',
            data: QS.stringify(data),
        })
    },
    recovery: function(data) {
        return request({
            url: `${base_.url}/api.wiki/recovery`,
            method: 'post',
            data: QS.stringify(data),
        })
    },
    clear: function(data) {
        return request({
            url: `${base_.url}/api.wiki/clear`,
            method: 'post',
            data: QS.stringify(data),
        })
    },
    conf: function(data) {
        return request({
            url: `${base_.url}/api.system/conf`,
            method: 'post',
            data: QS.stringify(data),
        })
    },
    suppliers: function(data) {
        return request({
            url: `${base_.url}/api.wiki/suppliers`,
            method: 'post',
            data: QS.stringify(data),
        })
    },
}